var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-widget iframe-widget"},[_c('iframe',{staticClass:"iframe-content",class:{
            'solen-content': _vm.widgetId === 'sunshine',
            'has-funnel': _vm.hasFunnel
        },attrs:{"title":"iframe-widget","frameBorder":"0","src":_vm.url}}),_vm._v(" "),(_vm.hasFunnel)?_c('FunnelFooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-159fee2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/IframeWidget.vue
// module id = null
// module chunks = 